@if (!commonQuestionnaireService.createMode) {
<div>
    @if (question.title) {
    <div class="title overflow-break-word full-width">
        <span>{{ question.number + 1 }}</span>
        <span [ngClass]="{ required: question.required && customerQuestionnaireService.displayVersion === 'full' }">
            {{ '. ' + question.title }}</span
        >
    </div>
    } @if (question.description) {
    <div class="description full-width m-t-5">
        {{ question.description }}
    </div>
    } @if (questionBody && currentAnswer) {
    <div class="m-t-30 p-10 width-625 main-grid-{{ questionBody.categories.length + 1 }}-{{ currentAnswer.length + 1 }}">
        <div class="grid-col-1 matrix-row w-100"></div>
        @for (category of questionBody.categories; track category; let i = $index) {
        <div class="grid-col-{{ i + 2 }} matrix-row w-100">
            <div class="m-l-5 fs-12">{{ category.name }}</div>
        </div>
        } @for (option of currentAnswer; track option; let k = $index) {
        <mat-radio-group
            [disabled]="commonQuestionnaireService.reviewMode && questionReview?.notification_type !== 'modify'"
            class="grid-row-{{ k + 2 }}-{{ questionBody.categories.length + 1 }} matrix-row w-100"
            color="primary"
        >
            <p class="grid-cell-{{ k + 1 }}-1 matrix-row-text fs-12 m-b-0">
                {{ option.label }}
            </p>
            @for (category of questionBody.categories; track category; let j = $index) {
            <div class="grid-cell-{{ k + 1 }}-{{ j + 2 }} m-l-5 m-t-5">
                <mat-radio-button
                    [disabled]="commonQuestionnaireService.reviewMode && questionReview?.notification_type !== 'modify'"
                    [value]="category.name"
                    (change)="onOptionChange(option, category)"
                    [checked]="getCategoryStatus(option, category)"
                >
                </mat-radio-button>
            </div>
            }
        </mat-radio-group>
        }
    </div>
    }
    <app-question-footer
        (questionMarked)="onQuestionMarked($event)"
        [showOk]="hasAllOptionsChecked()"
        [question]="question"
        [questionIndex]="questionIndex"
    ></app-question-footer>
</div>
} @if (commonQuestionnaireService.createMode) {
<div class="matrix question-create-panel overflow-auto">
    <form [formGroup]="matrixGroup.group">
        <div class="title no-border full-width">
            <div class="full-width input-form-field questionTitle m-t-10">
                @if (question.title) {
                <div class="title-number w-10-percent">
                    <mat-form-field
                        appearance="outline"
                        class="full-width title-input input-form-field"
                    >
                        <textarea
                            disabled
                            matInput
                            type="text"
                            class="title-textarea"
                            style="margin-top: 0; resize: none"
                            >{{ questionTitle }}</textarea
                        >
                    </mat-form-field>
                </div>
                }
                <div class="m-l--10">
                    <mat-form-field
                        appearance="outline"
                        class="full-width title-input input-form-field"
                    >
                        <textarea
                            matInput
                            type="text"
                            #titleTextarea
                            [placeholder]="questionPlaceholder"
                            (ngModelChange)="onTitleChange()"
                            formControlName="title"
                            cdkTextareaAutosize
                            class="title-textarea m-t-0"
                            cdkAutosizeMinRows="1"
                            cdkAutosizeMaxRows="5"
                            required
                        ></textarea>
                        @if (TitleControl?.invalid) {
                        <mat-error>
                            <span>{{ matrixGroup.getReadableError('title') }}</span>
                        </mat-error>
                        }
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="description text-left fs-13 m-t-7 no-border full-width">
            <mat-form-field
                appearance="outline"
                class="full-width input-form-field"
            >
                <textarea
                    matInput
                    type="text"
                    [placeholder]="descriptionPlaceholder"
                    (ngModelChange)="onDescriptionChange()"
                    formControlName="description"
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="5"
                    class="description-textarea"
                ></textarea>
            </mat-form-field>
        </div>
        @if (questionBody && currentAnswer) {
        <div
            class="answer-body-container
         main-grid-edit-{{ questionBody.categories.length + 2 }}-{{ questionBody.options.length + 2 }} full-width m-t-32"
        >
            <p
                class="grid-cell-edit-1-1"
                style="min-width: 80px"
            ></p>
            @for (category of questionBody.categories; track category; let i = $index) {
            <div class="text-center p-l-10 p-r-10 grid-cell-edit-categories">
                <mat-form-field
                    appearance="outline"
                    class="no-border"
                >
                    <textarea
                        matInput
                        class="matrix-category fs-12 height-30 grid-cell-edit-1-{{ i + 2 }} text-ellipsis text-center font-italic"
                        type="text"
                        maxlength="50"
                        [placeholder]="optionColumnPlaceholder"
                        [formControlName]="'category_' + i"
                        (ngModelChange)="onCategoryChange(i)"
                        cdkTextareaAutosize
                        cdkAutosizeMinRows="1"
                        cdkAutosizeMaxRows="5"
                        required
                    ></textarea>
                </mat-form-field>
            </div>
            }
            <p class="grid-cell-1-{{ questionBody.categories.length + 2 }}"></p>
            @for (option of questionBody.options; track option; let optionIndex = $index; let i = $index) {
            <div
                class="grid-cell-edit-{{ optionIndex + 2 }}-1 fs-12
                            p-b-5 text-ellipsis d-flex grid-cell-edit-labels font-italic"
            >
                <mat-form-field
                    appearance="outline"
                    class="no-error-input no-border"
                >
                    <textarea
                        matInput
                        type="text"
                        maxlength="50"
                        class="text-left"
                        [placeholder]="optionRowPlaceholder"
                        [formControlName]="'option_' + optionIndex"
                        (ngModelChange)="onOptionValueChanged(optionIndex)"
                        cdkTextareaAutosize
                        cdkAutosizeMinRows="1"
                        cdkAutosizeMaxRows="5"
                        required
                    ></textarea>
                </mat-form-field>
            </div>
            } @for (cat of questionBody.categories; track cat; let catIndex = $index) { @for (op of questionBody.options; track op; let
            opIndex = $index) {
            <div class="grid-cell-edit-{{ opIndex + 2 }}-{{ catIndex + 2 }} m-auto m-b-5 h-100">
                <mat-radio-button
                    [value]="getCategoryBasedOnIndex(catIndex).name"
                    disabled
                    (change)="onOptionChange(getOptionBasedOnIndex(opIndex), getCategoryBasedOnIndex(catIndex))"
                    [checked]="getCategoryStatus(getOptionBasedOnIndex(opIndex), getCategoryBasedOnIndex(catIndex))"
                    class="m-l-7 text-center"
                >
                </mat-radio-button>
            </div>
            } } @for (option of questionBody.options; track option; let optionIndex = $index) { @if
            (shouldShowDeleteButtonForOption(optionIndex)) {
            <mat-icon
                class="cancel-btn fs-18 grid-cell-edit-{{ optionIndex + 2 }}-{{ questionBody.categories.length + 2 }}
                                h-100 m-t-2 m-auto cursor-pointer"
                [ngClass]="{ 'btn-disabled': !checkMinRowRequirements() }"
                (click)="deleteQuestionField(optionIndex, 'option')"
            >
                cancel
            </mat-icon>
            } } @for (cat of questionBody.categories; track cat; let columnIndex = $index) { @if
            (shouldShowDeleteButtonForCategory(columnIndex)) {
            <mat-icon
                class="cancel-btn fs-18 grid-cell-edit-{{ questionBody.options.length + 2 }}-{{ columnIndex + 2 }}
                                m-auto w-100 text-center cursor-pointer"
                [ngClass]="{ 'btn-disabled': !checkMinColRequirements() }"
                (click)="deleteQuestionField(columnIndex, 'column')"
            >
                cancel
            </mat-icon>
            } }
        </div>
        }
    </form>
    <div class="d-flex-center justify-end edit-mode-question-footer m-t-10">
        <p
            (click)="
                addQuestionField(
                    questionBody.options,
                    cstQuestionnaireService.getObjectWithRandomId(optionObj),
                    questionBody.options.length
                )
            "
            class="add-btn left-btn fs-12 fs-11 p-t-1 p-l-15 p-r-15 p-b-1"
        >
            Add row
        </p>
        <p
            (click)="addCategory()"
            class="add-btn fs-12 p-t-1 p-l-15 p-b-1"
        >
            Add column
        </p>
    </div>
    @if (!allCellsCompleted()) {
    <mat-error class="m-b-20 text-center">
        <span>All categories and options must have a text</span>
    </mat-error>
    }
</div>
}
